<template>
      <div>
          <barra-navegacao :visiblebutton="true"/>
            <b-card
            v-for="(cs,index) in corredorSalas" :key="index" 
                @click="iniciarOcorrencia(cs)"            
                class="modern-nav-card">
              <div>
                <strong>{{cs.sala ? cs.sala.descricaoCompleta : cs.descricaoCompleta}}</strong>
              </div>
            </b-card>
      </div>
</template>

<script>
import BarraNavegacao from '../components/BarraNavegacao.vue';

export default {
  components: { BarraNavegacao },
  data(){
    return{
      corredorSalas: [],
      local: 0,
      idAndar: 0,
      idBloco: 0,
      idCorredor: 0
    }
  },

  created(){
    this.idAndar = this.$route.params.idAndar;
    this.idBloco = this.$route.params.idBloco;
    this.idCorredor = this.$route.params.idCorredor;
    this.listarSalas(this.idCorredor);
  },

  methods:{
    listarSalas(idCorredor) {
      this.$http
        .get(`/corredor-salas/bloco/${this.idBloco}/andar/${this.idAndar}/corredor/${idCorredor}`)
        .then((res) => {
          this.corredorSalas = res.data;
      });
    },

    iniciarOcorrencia(cs) {
      this.local = cs.idCorredorSala;
      this.$router.push('/ocorrencia/c_'+this.local)
    },
  }
};
</script>

<style >

</style>